import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { IconCacheService } from './fcp-icon-cache.service';
import { IconName } from './icon-registry';

@Component({
    selector: 'fcp-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe],
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `
        @if (svgContent() | async; as svgContent) {
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                [attr.data-icon]="icon()"
                [innerHTML]="svgContent"
                [class]="iconClasses()"
            ></svg>
        }
    `,
    styleUrls: ['./fcp-icon.component.less']
})
export class FcpIconComponent {
    e2e = input<string | null>(null);
    icon = input.required<IconName>();
    color = input<FcpIconColors>();
    size = input<FcpIconSizes>(FcpIconSizes.Large);

    private iconCacheService = inject(IconCacheService);
    private colorClass = computed(() => {
        const colorClasses = {
            [FcpIconColors.Darkest]: 'color-darkest',
            [FcpIconColors.Darker]: 'color-darker',
            [FcpIconColors.Dark]: 'color-dark',
            [FcpIconColors.Lighter]: 'color-lighter',
            [FcpIconColors.Lightest]: 'color-lightest',
            [FcpIconColors.Disabled]: 'color-disabled'
        };
        return colorClasses[this.color()];
    });
    private sizeClass = computed(() => {
        const sizeClasses = {
            [FcpIconSizes.Small]: 'size-small',
            [FcpIconSizes.Large]: 'size-large',
            [FcpIconSizes.ExtraLarge]: 'size-extra-large'
        };
        return sizeClasses[this.size()];
    });

    iconClasses = computed(() => `${this.colorClass()} ${this.sizeClass()} fill-current inline-block`);
    svgContent = computed(() => this.iconCacheService.getIcon(this.icon()));
}

export enum FcpIconSizes {
    Small = 'small',
    Large = 'large',
    ExtraLarge = 'extra-large'
}

export enum FcpIconColors {
    Darkest = 'darkest',
    Darker = 'darker',
    Dark = 'dark',
    Lighter = 'lighter',
    Lightest = 'lightest',
    Disabled = 'disabled'
}
